import { CarrierFormFields } from '../carrier-form-fields.component';
import { CarrierFormModal } from '../carrier-form-modal.component';
import { EditCarrierActionProps, useEditCarrierAction } from './edit-carrier-action.hook';

export function EditCarrierModal(props: EditCarrierActionProps) {
  const { state, handlers, control, handleSubmit, image, onImageUploaded, sortOrder } = useEditCarrierAction(props);

  return (
    <CarrierFormModal
      title={`Edit ${props.carrier.name}`}
      saving={state.saving}
      error={state.error}
      onCancel={handlers.onCancel}
      onSubmit={handleSubmit(handlers.onSubmit)}
    >
      <CarrierFormFields control={control} image={image} onImageUploaded={onImageUploaded} sortOrder={sortOrder} />
    </CarrierFormModal>
  );
}
